import React from "react";
// Style
import "../../styles/pos/PosStyle.scss";
// Components
import PosHeader from "../../components/pos/PosHeader";
import PosContent from "../../components/pos/PosContent";
import PosDetail from "../../components/pos/PosDetail";
import { PosMenuControl, PosSaleList } from "../../components/pos/PosPopupMenu";
// Recoil
import { useRecoilValue } from "recoil";
import { activeTable, menuState } from "../../atom/pos";

function PosMain() {
  // 포스 메인 화면
  // table 값이 있으면 메인 / 디테일
  // menuType 값에 따라 매출조회 / 통합관리 화면 노출

  // Recoil State
  const table = useRecoilValue(activeTable);
  const menuType = useRecoilValue(menuState);

  return (
    <div className='flex col'>
      <PosHeader table={table} />
      {table < 1 ? <PosContent /> : <PosDetail />}
      {menuType === 1 ? (
        <PosSaleList />
      ) : menuType === 2 ? (
        <PosMenuControl />
      ) : null}
    </div>
  );
}

export default PosMain;
